(function(){
  function getOptionValue(btn){
    return btn.getAttribute('data-option-value') || btn.getAttribute('data-value') || '';
  }
  function getOptionName(wrap){
    return wrap.getAttribute('data-option-name') || wrap.getAttribute('data-select-name') || '';
  }

  // NEW: sync button disabled states based on the hidden <select> options
  function syncWrapAvailability(wrap){
    const form = wrap.closest('form');
    if(!form) return;

    const selectName = wrap.getAttribute('data-select-name') || getOptionName(wrap);
    if(!selectName) return;

    const sel = form.querySelector(`select[name="options[${CSS.escape(selectName)}]"]`);
    if(!sel) return;

    // Build a lookup: option value -> disabled?
    const disabledByValue = {};
    Array.from(sel.options).forEach(opt => {
      // Shopify/themes often mark unavailable option values as disabled
      // Some themes may also use aria-disabled or data-available.
      const isDisabled =
        opt.disabled ||
        opt.getAttribute('aria-disabled') === 'true' ||
        opt.getAttribute('data-available') === 'false';

      disabledByValue[String(opt.value)] = !!isDisabled;
    });

    // Apply to matching buttons
    wrap.querySelectorAll('button.option-btn, button.option-swatch').forEach(btn => {
      const val = getOptionValue(btn);
      const isSoldOut = !!disabledByValue[String(val)];

      if(isSoldOut){
        btn.classList.add('is-sold-out');
        btn.setAttribute('aria-disabled','true');
        btn.setAttribute('disabled','disabled');
        // If it was selected but now sold out, unselect it visually
        if(btn.classList.contains('is-selected') || btn.classList.contains('is-active')){
          btn.classList.remove('is-selected','is-active');
          btn.setAttribute('aria-pressed','false');
        }
      } else {
        btn.classList.remove('is-sold-out');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('disabled');
      }
    });
  }

  // NEW: sync all option groups in a form
  function syncFormAvailability(form){
    form.querySelectorAll('.option-buttons').forEach(syncWrapAvailability);
  }

  function onClick(e){
    const btn = e.target.closest('.option-btn, .option-swatch');
    if(!btn) return;

    // Don’t allow clicking sold-out
    if(btn.classList.contains('is-sold-out') || btn.hasAttribute('disabled')) return;

    const wrap = btn.closest('.option-buttons');
    if(!wrap) return;

    wrap.querySelectorAll('.is-active, .is-selected').forEach(el=>{
      el.classList.remove('is-active','is-selected');
      el.setAttribute('aria-pressed','false');
    });

    btn.classList.add('is-active','is-selected');
    btn.setAttribute('aria-pressed','true');

    const selectName = wrap.getAttribute('data-select-name') || getOptionName(wrap);
    const form = btn.closest('form');

    if(form && selectName){
      const sel = form.querySelector(`select[name="options[${selectName}]"]`);
      if(sel){
        sel.value = getOptionValue(btn);
        sel.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }

    document.dispatchEvent(new CustomEvent('option:changed',{
      detail:{ name: getOptionName(wrap), value: getOptionValue(btn) }
    }));

    // NEW: after any click change, resync availability for all option groups
    if(form) syncFormAvailability(form);
  }

  document.addEventListener('option:changed', (ev)=>{
    const name = (ev.detail.name || '').toLowerCase();
    if(name !== 'color' && name !== 'colour') return;
    document.querySelectorAll('.js-color-name').forEach(el=>{ el.textContent = ev.detail.value; });
  });

  // NEW: whenever any option <select> changes (theme logic updates disabled options),
  // resync buttons in that form.
  document.addEventListener('change', (e)=>{
    const sel = e.target;
    if(!(sel && sel.tagName === 'SELECT')) return;
    const form = sel.closest('form');
    if(form) syncFormAvailability(form);
  });

  // NEW: initial sync on page load
  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('form').forEach(syncFormAvailability);
  });

  document.addEventListener('click', onClick);
})();
